export default {
    LOGO: require("../Assets/Images/logo.png"),
    // USER: require("../Assets/Images/icons/user.svg"),
    PASSWORD: require("../Assets/Images/icons/password.svg"),
    ADDUSER: require("../Assets/Images/icons/add.svg"),
    REMOVEUSER: require("../Assets/Images/icons/remove.svg"),
    TENANT: require("../Assets/Images/icons/tenanticon.svg"),
    USER: require("../Assets/Images/icons/usericon.svg"),
    SPINNER: require("../Assets/Images/spinner.gif"),
    MAIL: require("../Assets/Images/icons/mail.svg"),
    MICROFTLOGO: require("../Assets/Images/icons/microsoft.svg"),
    LOGOUT: require("../Assets/Images/icons/logout.svg"),
    SEARCH: require("../Assets/Images/icons/search.svg"),
    AVATAR: require("../Assets/Images/icons/avatar.svg"),
    ASSESSMENT: require("../Assets/Images/tenantadmin/assessment.png"),
    ASSIGNMENT: require("../Assets/Images/tenantadmin/assignment.png"),
    BACK: require("../Assets/Images/tenantadmin/back.svg"),
    CHART: require("../Assets/Images/tenantadmin/chart.jpg"),
    CHECKCIRCLE: require("../Assets/Images/tenantadmin/check_circle.png"),
    CLOSED: require("../Assets/Images/tenantadmin/closed.svg"),
    CLOSEDWHITE: require("../Assets/Images/tenantadmin/closeWhite.svg"),
    DASHBOARDICON: require("../Assets/Images/tenantadmin/dashboard-ico.png"),
    DASHBOARD: require("../Assets/Images/tenantadmin/dashboard.png"),
    EDITICON: require("../Assets/Images/tenantadmin/edit.svg"),
    PDF: require("../Assets/Images/tenantadmin/pdf.svg"),
    REFRESH: require("../Assets/Images/tenantadmin/refresh.svg"),
    ERROR1: require("../Assets/Images/tenantadmin/error.png"),
    ERROR2: require("../Assets/Images/tenantadmin/error.svg"),
    EXPAND: require("../Assets/Images/tenantadmin/expand.svg"),
    EXPANDGREEN: require("../Assets/Images/tenantadmin/expandgreen.svg"),
    LOGOICON: require("../Assets/Images/tenantadmin/logo.png"),
    MOREICON: require("../Assets/Images/tenantadmin/more.svg"),
    OPEN: require("../Assets/Images/tenantadmin/open.svg"),
    SEARCHICON: require("../Assets/Images/tenantadmin/search.png"),
    TIMELINE: require("../Assets/Images/tenantadmin/timeline.svg"),
    USERICON: require("../Assets/Images/tenantadmin/user.png"),
    VIEWLIST: require("../Assets/Images/tenantadmin/viewlist.svg"),
    WARNING: require("../Assets/Images/tenantadmin/warning.png"),
    HOME: require("../Assets/Images/tenantadmin/home.svg"),
    LOGOTHUMBNAIL : require("../Assets/Images/logothumbnail.png"),
    UNAUTH : require("../Assets/Images/unauthorized-person.svg"),
    ADDGREENICON : require("../Assets/Images/icons/addgreen.svg"),
    CLOSE : require("../Assets/Images/icons/close.svg"),
    BACKGREEN : require("../Assets/Images/icons/arrow_back_green.svg"),
    UNIT : require("../Assets/Images/icons/unit.svg"),  
    FILE : require("../Assets/Images/icons/file.svg"),
    VIEWDATA : require("../Assets/Images/icons/view_data.svg"),  
    DELETE : require("../Assets/Images/tenantadmin/delete-red.svg"),  
    CHECKWHITE : require("../Assets/Images/tenantadmin/check-white.svg"), 
    CHECKGREEN : require("../Assets/Images/tenantadmin/checkgreen.svg"),  
    INFOBTN : require("../Assets/Images/tenantadmin/info-button.svg"),
    ELIVATE : require("../Assets/Images/tenantadmin/elivate.svg"),
    SETTINGS : require("../Assets/Images/tenantadmin/settings.svg"),
    IMPACTS : require("../Assets/Images/tenantadmin/impacts.svg"),
    MANAGE : require("../Assets/Images/tenantadmin/manage.svg"),
    WARN : require("../Assets/Images/tenantadmin/warning.svg"),
    TRASH : require("../Assets/Images/tenantadmin/trash.svg"),
    ADDGREEN : require("../Assets/Images/tenantadmin/addgreen.svg"),
    DOCUMENT : require("../Assets/Images/tenantadmin/document.svg"),
    DOCUMENTBLUE : require("../Assets/Images/icons/documentblue.svg"),
    TEMPLATE : require("../Assets/Images/tenantadmin/template.svg"),
    RISK1 : require("../Assets/Images/tenantadmin/risk1.jpg"),
    RISK2 : require("../Assets/Images/tenantadmin/risk2.jpg"),
    RISK3 : require("../Assets/Images/tenantadmin/risk3.jpg"),
    RISK4 : require("../Assets/Images/tenantadmin/risk4.jpg"),
    RISK5 : require("../Assets/Images/tenantadmin/risk5.jpg"),
    RISK6 : require("../Assets/Images/tenantadmin/risk6.jpg"),
    UPLOAD : require("../Assets/Images/tenantadmin/upload.svg"),
    BARCHART : require("../Assets/Images/tenantadmin/barChart.svg"),
    DOUGHNUTCHART : require("../Assets/Images/tenantadmin/DoughnutChart.svg"),
    BUBBLECHART : require("../Assets/Images/tenantadmin/BubbleChart.svg"),
    GAUGECHART : require("../Assets/Images/tenantadmin/GaugeChart.svg"),
    PIECHART : require("../Assets/Images/tenantadmin/PieChart.svg"),
    GRIDCHART : require("../Assets/Images/tenantadmin/GridChart.svg"),
    LINECHART : require("../Assets/Images/tenantadmin/linechart.svg"),
    FILTER : require("../Assets/Images/tenantadmin/filter.svg"),
    SORT : require("../Assets/Images/tenantadmin/sort.svg"),
    // SHARE : require("../Assets/Images/tenantadmin/share.svg"),
    SHARE : require("../Assets/Images/tenantadmin/share.svg"),
    // DOWNLOAD : require("../Assets/Images/tenantadmin/download.svg"),
    VIEWFULLVIEW : require("../Assets/Images/tenantadmin/viewfullview.svg"),
    SHRINK : require("../Assets/Images/tenantadmin/shrink.svg"),
    LOCK : require("../Assets/Images/icons/Lock.svg"),
    UNLOCK : require("../Assets/Images/icons/Unlock.svg"),
    DROPDOWNGREEN : require("../Assets/Images/icons/DropDownGreen.svg"),
    AREACHART : require("../Assets/Images/tenantadmin/area-chart.svg"),
    HEATMAP : require("../Assets/Images/tenantadmin/heatmap.svg"),
    ADDWHITE : require("../Assets/Images/tenantadmin/add-white.svg"),
    HISTORY : require("../Assets/Images/tenantadmin/history.svg"),
    MENU : require("../Assets/Images/tenantadmin/menu.svg"),
    BUSINESS : require("../Assets/Images/tenantadmin/business.svg"),
    IMPACTSICON : require("../Assets/Images/icons/adminIcon01.svg"),
    WORKSTREAM : require("../Assets/Images/icons/adminIcon02.svg"),
    PROJECTSTAGE : require("../Assets/Images/icons/adminIcon03.svg"),
    RISKTYPE : require("../Assets/Images/icons/adminIcon04.svg"),
    WORKSTREAMTYPE : require("../Assets/Images/icons/adminIcon05.svg"),
    ALERT : require("../Assets/Images/icons/alert.svg"),
    RISKWELLLOGO : require("../Assets/Images/RiskwellLogo.svg"),
    STAIRS : require("../Assets/Images/icons/stairs.svg"),
    DOWNLOAD : require("../Assets/Images/icons/download.svg"),
    KEY : require("../Assets/Images/icons/key.svg"),
    STREAMING : require("../Assets/Images/icons/streaming.svg"),
    ANALYTICS : require("../Assets/Images/icons/analytics.svg"),
    SCENARIO : require("../Assets/Images/icons/scenario.svg"),
    UPLOADICON : require("../Assets/Images/icons/upload.svg"),
    DELETEFROMHOME : require("../Assets/Images/icons/deleteFromHome.svg"),
    XLSX : require("../Assets/Images/icons/xlsx.svg"),
    DOTSMENU : require("../Assets/Images/icons/dotsmenu.svg"),
    CHECKCIRCLEGREEN : require("../Assets/Images/icons/checkGreen.svg"),
    PROTECT : require("../Assets/Images/icons/protect.svg"),
    ARROW : require("../Assets/Images/icons/arrow.svg"),
    CART : require("../Assets/Images/tenantadmin/share.svg"),
    VIEW : require("../Assets/Images/icons/view.svg"),
    ATTACH : require("../Assets/Images/icons/attachment.svg"),
    EMAIL : require("../Assets/Images/icons/email.svg"),
    PLAY : require("../Assets/Images/icons/play.svg"),
    // SIDEBAR : require("../Assets/Images/icons/sidebar.svg"),
    RECYCLE:require("../Assets/Images/icons/recycle.svg"),
    NOTACCESS:require("../Assets/Images/icons/notaccess.svg"),
	FILTERWHITE:require("../Assets/Images/icons/filter.svg"),
    TEXT:require("../Assets/Images/icons/text.svg"),
    BLUETEXT:require("../Assets/Images/icons/bluetext.svg"),
    UNAPPROVE:require("../Assets/Images/icons/unapproved.svg"),
    CLOSEDRISK:require("../Assets/Images/icons/closed.svg"),
    TYPES:require("../Assets/Images/icons/types.svg"),
}



